import {
  Box,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FcApproval } from 'react-icons/fc';
import {
  IQuestionEditorProps,
  Question,
} from '@grcs/views/shared/components/editors/QuestionEditor';
import { parseQuestions } from '@grcs/utils/content/parseQuestions';
import { Empty } from '../ui/Empty';

export const Questions: React.FC<IQuestionEditorProps> = ({
  value,
  showAnswer,
}) => {
  const questions: Question[] = parseQuestions(value);

  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const bgColor = useColorModeValue('white', 'gray.800');
  const flexColor = useColorModeValue('green.50', 'green.900');

  if (!value || value.length === 0) {
    return <Empty>No Question</Empty>;
  }

  return (
    <Stack spacing={6}>
      {questions.map((question, questionIndex) => (
        <Box
          key={questionIndex}
          borderWidth="1px"
          borderRadius="md"
          borderColor={borderColor}
          bg={bgColor}
          p={4}
          boxShadow="sm"
        >
          <Stack spacing={3}>
            <Text fontWeight="semibold">
              {`${questionIndex + 1}. ${question.question}`}
            </Text>

            <Stack spacing={2}>
              {question.choices.map((choice, choiceIndex) => {
                const isCorrect = showAnswer && question.answer[choiceIndex];
                return (
                  <Flex
                    key={choiceIndex}
                    align="center"
                    gap={2}
                    pl={2}
                    py={1}
                    bg={isCorrect ? flexColor : 'transparent'}
                    borderRadius="md"
                  >
                    <Text fontWeight={isCorrect ? 'bold' : 'normal'}>
                      {`${String.fromCharCode(65 + choiceIndex)}. ${choice}`}
                    </Text>
                    {isCorrect && <Icon as={FcApproval} boxSize={4} />}
                  </Flex>
                );
              })}
            </Stack>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
